(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('agendamentoRelatorioEleitoral', {
        url: "/membro/relatorioEleitoral/agendamento",
        templateUrl: 'module/corregedoria/relatorioEleitoral/agendamento/agendamento.html',
        controller: 'AgendamentoRelatorioEleitoral',
        controllerAs: 'vm',
      });
  }

})();